import { AxiosRequestHeaders } from 'axios';
import axiosObject, { authAxios } from './axios';
import { isDemoMode } from '../demo/demoMode';
import { resolveDemoRequest } from '../demo/demoApi';

export const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:9100';

export type MakeRequest = {
  url: string;
  method: string;
  data?: unknown;
  params?: unknown;
  headers?: AxiosRequestHeaders;
  signal?: AbortSignal;
  isAuthRequest?: boolean;
};

export const makeRequest = async (req: MakeRequest) => {
  // Demo mode: never touch the network — return fully fake data instead.
  if (isDemoMode()) {
    return resolveDemoRequest({ url: req.url, method: req.method, data: req.data, params: req.params });
  }

  const { url, method, data, params, headers, signal, isAuthRequest } = req;
  const axiosInstance = isAuthRequest ? authAxios : axiosObject;
  return axiosInstance({
    url: baseURL + url,
    method,
    data,
    params,
    headers,
    signal,
  }).then((res: any) => {
    return res.data;
  });
};

 